import React, { Component } from "react";
import { Link } from "react-router-dom";
import { taraliteWhiteLogo } from "config/assets/logos";

import "./not-found.scss";
import Footer from "components/v2/footer/footer";
import Button from "components/v2/button/button";

class NotFound extends Component {
  render() {
    return (
      <table className="custom-page-container" cellPadding="0" cellSpacing="0" border="0">
        <tbody>
          <tr>
            <td>
              <div className="custom-header">
                <ul className="topbar-container">
                  <li>
                    <Link to="/">
                      <img src={taraliteWhiteLogo} alt="Taralite Logo" />
                    </Link>
                  </li>
                </ul>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="not-found-content">
                <span>Oops...</span>
                <span className="desc">Kami mohon maaf atas ketidaknyamanannya.</span>
                <span className="desc">Sepertinya halaman yang kamu cari tidak tersedia atau telah dihapus</span>
                <Link to="/">
                  <Button modifier={{ secondary: true }}>Kembali ke halaman awal</Button>
                </Link>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <Footer />
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}

export default NotFound;
